import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { NotificationsProvider } from "@mantine/notifications";
import AppRoutes from "./AppRoutes";
import { Loader } from "@mantine/core";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { CookiesProvider } from "react-cookie";

ReactDOM.render(
	<CookiesProvider>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				{/* <React.StrictMode> */}
				<MantineProvider
					withNormalizeCSS
					withGlobalStyles
					theme={{
						fontFamily: "SFPro Display, sans-serif",
						colorScheme: "dark",
						colors: {
							ivisit_dark: [
								"#040F1F",
								"#061934",
								"#1f4a8880",
								"#09254E",
							],
							ivisit_light: [
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
								"#14B8E1",
							],
							white: ["#FFFFFF"],
						},
						primaryColor: "ivisit_light",
						white: "#FFFFFF",
						black: "#000000",
					}}
				>
					<ModalsProvider>
						<NotificationsProvider>
							<BrowserRouter>
								<Suspense fallback={<Loader />}>
									<AppRoutes />
								</Suspense>
							</BrowserRouter>
						</NotificationsProvider>
					</ModalsProvider>
				</MantineProvider>
				{/* </React.StrictMode> */}
			</PersistGate>
		</Provider>
	</CookiesProvider>,

	document.getElementById("root")
);
reportWebVitals();
